import _uniqueId from "lodash/uniqueId";
import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { checkGoalType, checkSubqchoices, getDCText, getGoalSummary, getReadOnlyInputText, hasNodeValue, isSubqchoice, isSubqchoiceNotNull, updateStructure, doNotDisplayText } from '@mummssoftware/utils/form-engine/form-engine-utils';
import { goals, horizontal, input, label, multiselect, singleselect } from '@mummssoftware/utils/form-engine/form-engine-constants';
import { styles } from '../../../utils';
import defaults from '../../../translations/en.json';

const getDCSegment = subqchoice => /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
  style: [styles.fontSizeTwelvePt, styles.paddingTopPointOneCm, styles.fontWeightBold]
}, `${getDCText(subqchoice)}`));

var _ref = /*#__PURE__*/React.createElement(View, null);

var _ref2 = /*#__PURE__*/React.createElement(View, null);

var _ref3 = /*#__PURE__*/React.createElement(View, null);

var _ref4 = /*#__PURE__*/React.createElement(View, null);

var _ref5 = /*#__PURE__*/React.createElement(View, null);

const renderField = (subqchoice, subMenu // eslint-disable-next-line consistent-return
) => {
  switch (subqchoice.controltype) {
    case label:
      return /*#__PURE__*/React.createElement(View, {
        key: `label-${subqchoice.id}-${subqchoice.questionpath}`,
        id: "read-only-label"
      }, /*#__PURE__*/React.createElement(View, {
        key: `li-${subqchoice.id}-${subqchoice.questionpath}`,
        style: {
          display: subqchoice.drawmode === horizontal ? 'flex' : undefined,
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(Text, {
        style: [styles.fontSizeTwelvePt, styles.paddingTopPointOneCm, styles.fontWeightBold]
      }, `${subqchoice.questionlabel}`), subMenu));

    case input:
      // @note subqchoice.isothercomment => to not get input component 2 times with the one from Other dropdown
      return !subqchoice.isothercomment ? /*#__PURE__*/React.createElement(View, {
        key: `input-${subqchoice.id}-${subqchoice.questionpath}`,
        id: "read-only-input"
      }, /*#__PURE__*/React.createElement(View, {
        style: [horizontal && {
          display: 'flex'
        }],
        key: `li-${subqchoice.id}-${subqchoice.questionpath}`
      }, doNotDisplayText(subqchoice) ? '' : /*#__PURE__*/React.createElement(Text, {
        style: [styles.fontSizeElevenPt, styles.paddingTopPointOneCm]
      }, `• ${getReadOnlyInputText(subqchoice)}`), subMenu)) : _ref;

    case singleselect:
    case multiselect:
      {
        return subqchoice.overwritedrawmode ? /*#__PURE__*/React.createElement(View, {
          key: `checkbox-${subqchoice.parentquestionpath}-${subqchoice.id}-read-only-select1`,
          id: "read-only-select"
        }, /*#__PURE__*/React.createElement(Text, {
          style: [styles.fontSizeElevenPt, styles.paddingTopPointOneCm],
          key: `li-${subqchoice.id}-${subqchoice.questionpath}`
        }, isSubqchoice(subqchoice) ? /*#__PURE__*/React.createElement(Text, {
          style: [styles.fontSizeElevenPt, styles.paddingTopPointOneCm]
        }, `• ${subqchoice.questionlabel}`) : _ref2), subMenu) : /*#__PURE__*/React.createElement(View, {
          key: `checkbox-${subqchoice.parentquestionpath}-${subqchoice.id}-${subqchoice.questionpath}-read-only-select2`,
          id: "read-only-select"
        }, /*#__PURE__*/React.createElement(View, {
          key: `li-${subqchoice.id}-${subqchoice.questionpath}`,
          style: [horizontal && {
            display: 'flex'
          }]
        }, isSubqchoice(subqchoice) ? /*#__PURE__*/React.createElement(Text, {
          style: [styles.fontSizeElevenPt, styles.paddingTopPointOneCm]
        }, `• ${subqchoice.questionlabel}`) : _ref3, subMenu));
      }

    case goals:
      {
        const uniqueId = _uniqueId('read-only-goals');

        return /*#__PURE__*/React.createElement(View, {
          key: `checkbox-${subqchoice.dc_id}-${subqchoice.id}-${subqchoice.legacyformid}-${uniqueId}`,
          id: "read-only-goals"
        }, /*#__PURE__*/React.createElement(View, {
          key: `li-${subqchoice.id}-${subqchoice.legacyformid}`
        }, subqchoice.dcdate ? /*#__PURE__*/React.createElement(View, {
          id: "dc-item"
        }, /*#__PURE__*/React.createElement(Text, {
          style: [styles.fontSizeElevenPt, styles.paddingTopPointOneCm]
        }, `• ${getGoalSummary(subqchoice)}`), /*#__PURE__*/React.createElement(Text, {
          style: [styles.fontSizeTwelvePt, styles.paddingTopPointOneCm, styles.fontWeightBold]
        }, `${getDCText(subqchoice)}`)) : /*#__PURE__*/React.createElement(Text, {
          style: [styles.fontSizeElevenPt, styles.paddingTopPointOneCm]
        }, `• ${getGoalSummary(subqchoice)}`), subMenu));
      }
    // case checkbox, radio and null:

    default:
      {
        // dc items are checkboxes
        const noLabel = subqchoice.dcdate;
        return /*#__PURE__*/React.createElement(View, {
          key: `checkbox-${subqchoice.questionpath}-id-${subqchoice.id}-path-${subqchoice.dcdate}-read-only-default`,
          id: "read-only-default"
        }, /*#__PURE__*/React.createElement(View, {
          key: `li-${subqchoice.id}-${subqchoice.questionpath}`,
          style: {
            display: subqchoice.drawmode === horizontal ? 'flex' : undefined
          }
        }, /*#__PURE__*/React.createElement(View, null, !noLabel ? /*#__PURE__*/React.createElement(Text, {
          style: [styles.fontSizeElevenPt, styles.paddingTopPointOneCm]
        }, `• ${isSubqchoice(subqchoice) && subqchoice.questionlabel}`) : _ref4, subqchoice.dcdate ? /*#__PURE__*/React.createElement(View, {
          id: "dc-item"
        }, /*#__PURE__*/React.createElement(Text, {
          style: [styles.fontSizeElevenPt, styles.paddingTopPointOneCm]
        }, `• ${subqchoice.questionlabel}`), getDCSegment(subqchoice)) : _ref5), subMenu));
      }
  }
};

var _ref6 = /*#__PURE__*/React.createElement(View, null);

var _ref7 = /*#__PURE__*/React.createElement(View, null);

const renderSubMenu = (restructuredFormData, depthLevel = 0, isHorizontal) => {
  const menuOptions = restructuredFormData.map(subqchoice => {
    if (checkGoalType(subqchoice)) {
      subqchoice.controltype = goals;
    }

    const hasOptions = checkSubqchoices(subqchoice) && !checkGoalType(subqchoice);
    let subMenu = _ref6;
    const hasValue = depthLevel === 0 ? true : isSubqchoice(subqchoice);
    const isHorizontalMode = subqchoice.drawmode === horizontal; // only render selected submenu and only if nested options exist

    if (hasValue && hasOptions) {
      const newDepthLevel = depthLevel + 1;
      const subChoices = subqchoice.subqchoices.filter(choice => choice.dcdate || isSubqchoiceNotNull(choice));
      subMenu = renderSubMenu(subChoices, newDepthLevel, isHorizontalMode);
    } // READ ONLY MODE : only display the field with value or if it has been DC


    const hasChoiceValue = hasNodeValue(subqchoice) || subqchoice.dcdate;
    return hasChoiceValue ? renderField(subqchoice, subMenu) : _ref7;
  });
  return /*#__PURE__*/React.createElement(View, {
    key: `div-key-${depthLevel}`
  }, /*#__PURE__*/React.createElement(View, {
    id: "read-only-ul",
    style: {
      paddingLeft: '.5cm',
      display: isHorizontal ? 'flex' : undefined
    }
  }, menuOptions));
};

var _ref8 = /*#__PURE__*/React.createElement(View, null);

export const CPPContentsPDF = ({
  formData,
  planTasks
}) => {
  let parsedFormData;

  if (formData && typeof formData === 'string') {
    try {
      parsedFormData = formData && JSON.parse(formData);
    } catch (e) {
      // catch JSON parse exceptions
      // TODO alert
      console.log('JSON PARSING ERROR', e);
    }
  } else {
    // Preview Form array type
    parsedFormData = formData;
  }

  if (parsedFormData && parsedFormData[0]) {
    updateStructure(parsedFormData);
  }

  const carePlanProblems = parsedFormData && parsedFormData[0] && /*#__PURE__*/React.createElement(View, null, renderSubMenu(parsedFormData));
  const noProblemsComponent = !planTasks ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
    style: [styles.fontSizeElevenPt, styles.paddingTopPointOneCm, styles.fontFamilyItalic]
  }, defaults.noCarePlanProblem)) : _ref8;
  return carePlanProblems || noProblemsComponent;
};